// extracted by mini-css-extract-plugin
export default {"todoitem":"b0c45f305922abb1255c","description":"e70e3385ce8d72b431f8"};